<template lang='pug' src='./custom-publications-recognition.pug'></template>

<script>
export default {
  props: {
    content: {
      type: [Object, Array]
    }
  },
  data () {
    return {
      activeImage: 0,
      showingModal: null
    }
  },
  mounted () {
    setInterval(() => {
      this.activeImage < this.content.slider.length - 1 ? this.activeImage++ : this.activeImage = 0
    }, 4000)
  },
  methods: {
    showModal (i) {
      this.showingModal = i
    },
    closeModal () {
      this.showingModal = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-publications-recognition.vue?31c82f90